<div class="pb-6">
  <h2 class="fw-bolder text-dark">{{ defaultValues.accountType | appAccountTranslate:'WIZARD.SHOP.SHOP_DATA':'WIZARD.ADVERTISER.ADVERTISER_DATA' }}</h2>
<!--  <div class="text-gray-400 fw-bold fs-6">-->
<!--    {{ "WIZARD.ACCOUNT_TYPE_HELP" | translate }}-->
<!--    <a href="#" class="link-primary fw-bolder"> {{ "WIZARD.ACCOUNT_TYPE_HELP_PAGE" | translate }} </a>-->
<!--  </div>-->
</div>
<app-validation-errors [backendValidationErrorsList]="backendValidationErrorsList"></app-validation-errors>
<form [formGroup]="form">
  <div>
    <div *ngIf="isShop()" class="mb-6 fv-row" style="min-height: 125px;">
      <label class="form-label mb-3 required">{{ "WIZARD.SHOP.SHOP_NAME" | translate }}</label>
      <input formControlName="name" type="text" class="form-control form-control-lg form-control-solid"
        placeholder="{{ 'WIZARD.SHOP.SHOP_NAME_PLACEHOLDER' | translate }}"
      />
      <div *ngIf="form.get('name')?.hasError('forbiddenCharacter')">
        <app-inline-message [message]="'_' + ('WIZARD.ADVERTISER.CHARACTER_NOT_ALLOWED' | translate)"></app-inline-message>
      </div>
      <div *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required') && !form.get('name')?.hasError('minlength')">
        <app-inline-message [message]="'WIZARD.SHOP.SHOP_NAME_REQUIRED' | translate"></app-inline-message>
      </div>
      <div *ngIf="form.get('name')?.touched && form.get('name')?.hasError('minlength') && form.get('name')?.value">
        <app-inline-message [message]="'COMMON.VALIDATION.MIN_LENGTH' | translate:{min: SHOP_NAME_MIN}"></app-inline-message>
      </div>
      <div *ngIf="form.get('name')?.touched && form.get('name')?.hasError('maxlength')">
        <app-inline-message [message]="'COMMON.VALIDATION.MAX_LENGTH' | translate:{max: ACCOUNT_NAME_MAX}"></app-inline-message>
      </div>
    </div>
    <div *ngIf="!isShop()" class="mb-6 fv-row" style="min-height: 125px;">
      <label class="form-label mb-3 required">{{ "WIZARD.ADVERTISER.ADVERTISER_NAME" | translate }}</label>
      <input formControlName="name" type="text" class="form-control form-control-lg form-control-solid"
        placeholder="{{ 'WIZARD.ADVERTISER.ADVERTISER_NAME_PLACEHOLDER' | translate }}"
      />
      <div *ngIf="form.get('name')?.hasError('forbiddenCharacter')">
        <app-inline-message [message]="'_' + ('WIZARD.ADVERTISER.CHARACTER_NOT_ALLOWED' | translate)"></app-inline-message>
      </div>
      <div *ngIf="isTouchedAndHasError(form, 'name', ['required', 'minlength'])">
        <app-inline-message [message]="'WIZARD.ADVERTISER.ADVERTISER_NAME_REQUIRED' | translate"></app-inline-message>
      </div>
      <div *ngIf="form.get('name')?.touched && form.get('name')?.hasError('maxlength')">
        <app-inline-message [message]="'COMMON.VALIDATION.MAX_LENGTH' | translate:{max: ACCOUNT_NAME_MAX}"></app-inline-message>
      </div>
    </div>
    <div class="mb-6 fv-row" *ngIf="isShop()">
      <label class="form-label mb-3 required">{{ "WIZARD.SHOP.SHOP_DOMAIN" | translate }}</label>
      <input
        formControlName="domain"
        type="text"
        class="form-control form-control-lg form-control-solid"
        placeholder="https://shop-domain.com"
      />
      <div
        *ngIf="isTouchedAndHasError(form, 'domain', ['required', 'maxlength'])"
      >
        <app-inline-message [message]="'WIZARD.SHOP.SHOP_DOMAIN_REQUIRED' | translate"></app-inline-message>
      </div>
      <div
        *ngIf="isTouchedAndHasError(form, 'domain', ['urlValidator'])"
      >
        <app-inline-message [message]="'WIZARD.SHOP.SHOP_DOMAIN_VALID_URL' | translate"></app-inline-message>
      </div>
    </div>
    <div class="mb-6 fv-row d-flex flex-wrap justify-content-between" *ngIf="isShop()">
      <div class="col-4 min-w-250px pb-5">
        <div><label class="form-label">{{ "WIZARD.SHOP_LOGO" | translate }}</label></div>
        <div class="h-100px w-200px">
          <app-image-input
            (update)="onLogoChanged($event)"
            [image]="form.get('logo')?.value?.file"
          ></app-image-input>
        </div>
      </div>
      <div class="col-7">
        <div class="p-5 mb-3 rounded text-center" style="background-color: #f5f8fa;">
          <span class="fw-bold text-nowrap">{{ "WIZARD.SHOP.SHOP_LOGO_REQUIREMENTS_TITLE" | translate }}</span><br/>
          <span [innerHTML]="'WIZARD.SHOP.SHOP_LOGO_REQUIREMENTS' | translate"></span>
        </div>
        <div *ngIf="form.get('logo.file')?.value">
          <div *ngIf="!form.get('logo.params.width')?.valid || !form.get('logo.params.height')?.valid">
            <app-inline-message [message]="'WIZARD.SHOP.SHOP_LOGO_DIMENSIONS_ERROR' | translate"></app-inline-message>
          </div>
          <div *ngIf="!form.get('logo.params.size')?.valid">
            <app-inline-message [message]="'WIZARD.SHOP.SHOP_LOGO_SIZE_ERROR' | translate"></app-inline-message>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!isShop()">
      <div class="col-lg-9 fv-row mb-6">
        <label class="form-label">{{ "WIZARD.CURRENCY" | translate }}</label>
      </div>
      <div class="col-lg-3 fv-row mb-6">
        <input name="currency" class="form-control form-control-lg form-control-solid" formControlName="currency">
      </div>
    </div>
  </div>
  <div class="separator border-gray-200 mt-6"></div>
  <div class="d-flex flex-stack pt-6">
    <div class="mr-2">
      <button
        type="button"
        class="btn btn-lg btn-light-primary me-3"
        (click)="prevStep.emit()"
      >
      <span
        [inlineSVG]="'./assets/media/icons/duotune/arrows/arr063.svg'"
        class="svg-icon svg-icon-4 me-1"
      ></span>
        {{'WIZARD.BACK'|translate}}
      </button>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-lg btn-primary"
        [disabled]="!form.valid"
        (click)="nextStep.emit()"
      >
        <span class="indicator-label">
            {{'WIZARD.CONTINUE' | translate}}
          <span
            [inlineSVG]="'./assets/media/icons/duotune/arrows/arr064.svg'"
            class="svg-icon svg-icon-3 ms-2 me-0"
          ></span>
        </span>
      </button>
    </div>
  </div>
</form>
